import React, { useState, useCallback, useEffect } from "react";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import {  selectorAPI, addDelegation, getDelgatingCustomers, getDelgatedCustomers, getClientContracts, postCustomerDelegation, getDelegationById, getContract } from "net/contracts";
import { useDispatch, useSelector } from "react-redux";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import {  Row, Col } from "react-grid-system";
import "views/contractView/styles/newElementFormStyles.css";
import { DatePicker, Button, InputAttach } from "@ds/ds-snam/react";
import {  useNavigate, useParams } from "react-router-dom";
import { DATE_FORMAT, RoutePath,  DocumentType, EntityType, DsLayout, ResponseStatus, ResponseCode, BadgeStatus, FormMode, AppUserRole, IAppUserProfile } from "shared/constants";
import {  IDocument, IDelegation, ICustomerDelegation } from "dataModels/contract";
import { FileStatusEnum, IFileUpload } from "dataModels/fileInput";
import moment from "moment";
import DSFileInput from "components/DSFileInput";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { showNotification, hideNotification } from "state/reducer/notificationSlice";
import { useTranslation } from "react-i18next";
import { DSFile } from "@ds/ds-snam";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { RootState } from "state/appStore";
import { Select, Input as TextInput } from "@ds/ds-snam/react";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";



interface MyISelectLabel extends ISelectLabel{
    maxBookableSlots?:string
}

const getDefaultFormData = (): ICustomerDelegation => {
    const defaultFormData: ICustomerDelegation = {
        delegationId: "", 
        delegatingBusinessId: "",
        delegatingBusinessName: "",
        delegatedBusinessId: "",
        delegatedBusinessName: "",
        contractId: "",
        contractCode: "",
        maxSlots: "",
        usedSlots:"",
        delegationAbilitation: true,
        documents:[
            {
                type: DocumentType.CUSTOMER_DELEGATION,
                name: "",
                size: 0,
                content: "",
                expire: Math.floor(Date.now() / 1000),
                status: BadgeStatus.TOAPPROVE
            }
        ]
    }
    return defaultFormData;
}



const CustomerDelegationForm: React.FC = (): JSX.Element => {
    const [formStep, setFormStep] = useState<number>(0);
    const { t } = useTranslation(['contract','app']);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formError, setFormError] = useState<boolean>(false);
    const { id , contractId } = useParams(); //contractId esiste solo se sono in edit
    const [formMode, setFormMode] = useState<number>(id ? FormMode.EDIT : FormMode.NEW);
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    
    const [delegatingCustomerList, setDelegatingCustomerList] = useState<MyISelectLabel[]>([]);
    const [delegatedCustomerList, setDelegatedCustomerList] = useState<MyISelectLabel[]>([]);
    const [delegatingCustomerContractList, setDelegatingCustomerContractList] = useState<MyISelectLabel[]>([]);
    const [maxBookableSlots, setMaxBookableSlots] = useState<string|null>(null);

    const [formData, setFormData] = useState<ICustomerDelegation>(getDefaultFormData());

    useEffect(()=>{
        if(formMode===FormMode.EDIT && id){
            dispatch(requestPending());
            getDelegationById(id)
                .then((response) => {
                    if(response.data && appUserRole!==AppUserRole.SALES_PROFILE && appUserRole!==AppUserRole.ADMIN){
                        response.data.documents[0].status=BadgeStatus.TOAPPROVE;
                    }
                    setFormData(response.data);
                })
                .catch(error => {
                    
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                })
                //devo recuperare max slots
                //voglio richiedere i contratto con contractId per prendere annualSlots
                if(contractId!==undefined){
                    dispatch(requestPending());
                    getContract(contractId)
                        .then((response) => {
                            const contractResponse = response.data;
                            setMaxBookableSlots(contractResponse.slot);
                            //console.log(contractResponse.slot) //questo sarebbe maxSlots
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => {
                            dispatch(requestPristine());
                        });
                }
                
            }

            
            
    },[])

    useEffect(() => {
        dispatch(requestPending());
        getDelgatingCustomers()
            .then((response: MyISelectLabel[]) => {
                /*let mock = [
                    {
                        "id": "1",
                        "label": "ACME XXX",
                        "value": "1"
                    },
                    {
                        "id": "2",
                        "label": "Stark Industries",
                        "value": "2"
                    }
                ]
                setDelegatingCustomerList(mock);*/
                setDelegatingCustomerList(response);
            })
            .catch(error => {
                
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }, [dispatch]);

    useEffect(()=>{
        if(formData.delegatingBusinessId!==''){
            dispatch(requestPending());
            getDelgatedCustomers(formData.delegatingBusinessId)
            .then((response: MyISelectLabel[]) => {
                /*let mock = [
                    {
                        "id": "3",
                        "label": "ACME 2",
                        "value": "3"
                    },
                    {
                        "id": "4",
                        "label": "Nuova Azienda 2",
                        "value": "4"
                    }
                ]
                setDelegatedCustomerList(mock);*/
                setDelegatedCustomerList(response);
            })
            .catch(error => {
                
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
            }
            
    },[formData.delegatingBusinessId])

    useEffect(()=>{
        if(formData.delegatingBusinessId!=='' && formData.delegatedBusinessId!==''){
            dispatch(requestPending());
            getClientContracts(formData.delegatingBusinessId,formData.delegatedBusinessId)
                .then((response: MyISelectLabel[]) => {
                    setDelegatingCustomerContractList(response);
                })
                .catch(error => {
                    
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                });
            } 
    },[formData.delegatingBusinessId,formData.delegatedBusinessId])

    const onTextInputChange = (inputEvent: Event) => {
        const fieldName = (inputEvent as CustomEvent).detail.input.name;
        let currentData: ICustomerDelegation = { ...formData };
        (currentData[fieldName as keyof ICustomerDelegation] as string) = (inputEvent as CustomEvent).detail.input.value;
        setFormData(currentData);
    }

    const prevStep = () => {
        const nextStep = formStep - 1;
        setFormStep(nextStep);
    }
    const nextStep = () => {
        const nextStep = formStep + 1;
        setFormStep(nextStep);
    }

    const validateStep = () => {
        if(formStep===0){
            if(formData.delegatingBusinessId==='' || formData.delegatedBusinessId==='' || formData.contractId==='' || formData.maxSlots==='' || 
                (maxBookableSlots!==null && Number(formData.maxSlots) > Number(maxBookableSlots)
            )
            ){
                return 1;
            }else{
                return  0;
            }
        }else if(formStep===1){
            if(formData.documents.length===0 || formData.documents[0].name===''){
                return 1;
            }else{
                return 0;
            }
        }else{
            return 0;
        }
    }

    const onDateInputChange = (inputEvent: Event) => {
        const date: string = (inputEvent as CustomEvent).detail.dateSelection;
        if(formData.documents[0]!==null){
            formData.documents[0].expire = moment.utc(date, DATE_FORMAT).unix();
        }
    }

    const saveFormData = useCallback(() => {
        dispatch(requestPending());
        postCustomerDelegation(formData)
            .then((response) => {
                //gestione errori business
                const popUpTitle:string = response.status===ResponseStatus.ERROR ? 'Error':(response.code===ResponseCode.UNPROCESSABLE_CONTENT? "Warning": t("transporter.delegationForm.popupTitle") );
                const popUpDescription:string = response.status===ResponseStatus.ERROR||response.code===ResponseCode.UNPROCESSABLE_CONTENT?response.message:t("transporter.delegationForm.popupText");
                const popUpStatus:NotificationsStatusType = response.status===ResponseStatus.ERROR?"error":(response.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");
                                
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
            })
            .catch(error => {
                navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
               
    }, [ dispatch, navigate,formData]);

    return (

        <>
            {formStep===0 &&   
                <>
                    <p className="pageTitle" style={{ marginBottom: "10px" }}>
                        {t("customer.customerDelegationForm.title_1")}
                        {formMode === FormMode.EDIT}
                        </p> 
                    <Row>
                        <Col xs={3}>
                        <div className="textInputWrapper">
                            {formMode !== FormMode.EDIT && <><Select
                                id="delegatingCustomerListSelector"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={delegatingCustomerList}
                                menuLabel={t("customer.customerDelegationForm.list_1")}
                                menuId="select-id"
                                isDisabled={delegatingCustomerList.length===0}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const customerSelected: MyISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(delegatingCustomerList, customerSelected);
                                    let currentFormData = { ...formData };
                                    currentFormData.delegatingBusinessId=customerSelected.value!;
                                    setFormData(currentFormData)
                                }}
                            ></Select>
                            <div style={{height:'16px'}}></div>
                            <Select
                                id="delegatedCustomerSelector"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={delegatedCustomerList} 
                                menuLabel={t("customer.customerDelegationForm.list_2")}
                                menuId="select-id"
                                isDisabled={formData.delegatingBusinessId==="" && delegatedCustomerList.length===0}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const customerSelected: MyISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(delegatedCustomerList, customerSelected);
                                    let currentFormData = { ...formData };
                                    currentFormData.delegatedBusinessId=customerSelected.value!;
                                    setFormData(currentFormData)
                                }}
                            ></Select>
                            <div style={{height:'16px'}}></div>
                            <Select
                                id="delegatingCustomerContractSelector"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={delegatingCustomerContractList} 
                                menuLabel={t("customer.customerDelegationForm.list_3")}
                                menuId="select-id"
                                isDisabled={formData.delegatingBusinessId===""|| formData.delegatedBusinessId==="" && delegatingCustomerContractList.length===0}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const contractSelected: MyISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(delegatingCustomerContractList, contractSelected);
                                    let currentFormData = { ...formData };
                                    currentFormData.contractId=contractSelected.value!;
                                    if(contractSelected.maxBookableSlots){
                                        setMaxBookableSlots(contractSelected.maxBookableSlots);
                                    }
                                    
                                    setFormData(currentFormData)
                                }}
                            ></Select></>}
                            <div style={{height:'16px'}}></div>
                            {<div className="textInputWrapper">
                                <TextInput
                                    inputLabel={t("customer.customerDelegationForm.maxSlots")}
                                    inputValue={formData.maxSlots}
                                    inputName="maxSlots"
                                    inputId="maxSlots"
                                    inputDescription={(maxBookableSlots!==null && formData.maxSlots && Number(formData.maxSlots) > Number(maxBookableSlots)) ? t("customer.customerDelegationForm.error_1"):""}
                                    inputStatus={(maxBookableSlots!==null && formData.maxSlots && Number(formData.maxSlots) > Number(maxBookableSlots))?"error":"default"}
                                    inputPlaceholder={""}
                                    isDisabled={formData.contractId===""}
                                    input-event-type="single_character"
                                    isNumberVariant={true} //STRINGTOONLYNUMBER
                                    isReadonly={false}
                                    maxDecimalDigits={0}
                                    onInputChange={onTextInputChange}
                                    minValue={0}
                                />
                            </div>}
                        </div>
                        <div><Button
                            buttonType="button"
                            buttonUIVariant="secondary"
                            buttonSize="medium"
                            buttonLabel={t("customer.customerDelegationForm.button_1")}//'Inserisci cliente'
                            buttonIcon="icon-add"
                            //isDisabled={!selectedContractId}
                            isDisabled={false}
                            buttonAriaLabel="insert customer button"
                            onClickEvent={() => {
                                navigate(RoutePath.CONTRACTS_NEW_CUSTOMER)
                            }}
                        ></Button></div>
                        <div style={{marginTop:'12px'}}><Button
                            buttonType="button"
                            buttonUIVariant="secondary"
                            buttonSize="medium"
                            buttonLabel={t("customer.customerDelegationForm.button_2")}//'Inserisci contratto'
                            buttonIcon="icon-add"
                            //isDisabled={!selectedContractId}
                            isDisabled={false}
                            buttonAriaLabel="insert contract button"
                            onClickEvent={() => {
                                navigate(RoutePath.CONTRACTS_NEW_CONTRACT)
                            }}
                        ></Button></div>
                        </Col>
                    </Row>    
                </>
            }

            {formStep===1 &&
            <>
                <Row>
                    <Col>
                        <div className="formSubTitle">
                            {t("customer.customerDelegationForm.sub_title_1")}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="fileInputWrapper">
                            <DSFileInput
                                title={t("customer.customerDelegationForm.sub_title_2")}
                                inputLabel={formData.documents.length ? t('dsComponents.fileInput.defaultStatus.title', {ns:'app'}) : t('contract.contractForm.sections.fileInput.unloadedFile')}
                                id="doc0"
                                accept="application/pdf, image/jpg, image/jpeg"
                                maxSize={10000000}
                                defaultStatus={formData.documents[0].name !== '' ? FileStatusEnum.UPLOADED : FileStatusEnum.DEFAULT}
                                onFileUpload={(fileUpload: IFileUpload, id: string) => {
                                    //console.log("on file upload", fileUpload, id);
                                    let currentFormData = { ...formData };
                                    let base64String = btoa(fileUpload.content);
                                    const documentObj: IDocument = {
                                        type: DocumentType.CUSTOMER_DELEGATION,//"securityTemplate",
                                        name: fileUpload.name,
                                        size: fileUpload.size,
                                        content: base64String,
                                        expire: moment(new Date(), DATE_FORMAT).unix(),
                                        status: appUserRole===(AppUserRole.SALES_PROFILE||appUserRole===AppUserRole.ADMIN)?BadgeStatus.APPROVED:BadgeStatus.TOAPPROVE
                                    }
                                    currentFormData.documents[0] = documentObj;
                                    setFormData(currentFormData);
                                    //console.log(formData)
                                }}
                            />
                        </div>
                        </Col>
                        </Row>
                        <Row>
                        {formData.documents[0].name !== '' ?
                            <div className="uploadedFileWrapper" style={{paddingLeft:'16px'}}>
                                <InputAttach
                                    attachName={formData.documents[0].name}
                                    firstButtonDisabled={false}
                                    secondButtonDisabled={false}
                                    inputLabel={t('contract.contractForm.sections.fileInput.attachTitle')}//"File caricato"
                                />
                            </div>
                            :
                            <></>
                        }
                        {formData.documents[0].name &&
                            <Col xs={12} md={3}>
                                <div className="expirationInputWrapper" style={{width:'196px'}}>
                                    <DatePicker
                                        id="scadenzaDocDelegation"
                                        datePickerTitle={t("transporter.delegationForm.expire")}//"scadenza"
                                        isRangePicker={false}
                                        datePickerVariant="full-date"
                                        datePickerPlaceholder=""
                                        startingYear={new Date().getFullYear()}
                                        endingYear={2099}
                                        defaultDate={new Date()}
                                        isDisabled={false}
                                        datePickerStatus="default"
                                        confirmButtonLabel="Conferma"
                                        disabledDates={{ lastDisabledDate: new Date(Date.now() - 86400000) }} 
                                        hasCloseButton={false}
                                        zIndex={999}
                                        isReadonly={false}
                                        isPanelTop={true}
                                        onDateSelection={(event: Event) => {
                                            onDateInputChange(event)
                                        }}
                                    ></DatePicker>
                                </div>
                            </Col>
                        }</Row>
                        <Row>
                            <Col>
                    </Col>
                </Row>
            </>
            }





            {!formError && <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.8rem" }}>
                {formStep > 0 && <Button
                    style={{ marginRight: "0.8rem" }}
                    id="backButton"
                    buttonType="button"
                    buttonUIVariant="secondary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.back', { ns: 'app' })}//"Indietro"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={()=>{
                        formMode === FormMode.NEW ? prevStep(): setFormStep(formStep-1)}
                    }
                />}
                {formStep < 1 && <Button
                    id="nextButton"
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.next', { ns: 'app' })}//"Continua"
                    buttonIcon=""
                    isDisabled={validateStep()!==0}
                    onClickEvent={() => {
                        let errors: number = validateStep();
                        if (errors === 0)
                            formMode === FormMode.NEW ? nextStep() : setFormStep(formStep + 1);
                    }}
                />}
                {formStep === 1 && <Button
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.confirm', { ns: 'app' })}//"Conferma"
                    buttonIcon=""
                    isDisabled={validateStep()!==0}
                    onClickEvent={(event: Event) => {
                        //console.log(formData)
                        let errors = validateStep();
                        if(errors===0){
                            saveFormData();
                        }
                        //saveFormData();
                    }}
                />}
            </div>}
            
        </>
    )
}
export default CustomerDelegationForm;